module.exports = __webpack_public_path__ + "img/payout-xiu-banner.2c70d1e8.svg";